import * as Model from './index';

export function defaultDropDownContent(): Model.DropdownObj {
  const defaultName = 'None';
  const option: Model.DropdownContentObj = {
    title: defaultName,
    description: '',
    disabled: false,
    selected: false,
  };
  const dropDown: Model.DropdownObj = new Model.DropdownObj();
  dropDown.options = [option];
  dropDown.disabled = false;
  dropDown.topic = defaultName;
  dropDown.setSelected(option);
  return dropDown;
}

export function selectionClientParamDefToDropDownContent(selectionDef: Model.SelectionClientParamDef): Model.DropdownObj {
  const { value } = selectionDef;
  const options: Model.DropdownContentObj[] = value.map((paramDef: Model.ClientParamDef<string>): Model.DropdownContentObj => {
    const option: Model.DropdownContentObj = {
      title: paramDef.name,
      disabled: paramDef.disabled,
      selected: false,
      description: paramDef.descriptions.join('\n').replace('\\n', '\n'),
    };
    return option;
  });
  const selectedOption: Model.DropdownContentObj | undefined = options.find((option: Model.DropdownContentObj) =>
    option.title === selectionDef.selected.name);
  const dropDown: Model.DropdownObj = new Model.DropdownObj();
  dropDown.options = options;
  dropDown.disabled = selectionDef.disabled;
  dropDown.topic = selectionDef.name;
  if (selectedOption) {
    dropDown.setSelected(selectedOption);
  }
  return dropDown;
}

export function hasParameterValue(parameter: Model.Parameter): boolean {
  return parameter.value ? parameter.value.length > 0 : false;
}

export function generateId(): string {
  return '_' + Math.random().toString(36).substr(2, 9);
}

export function countSequenceLength(sequence: string): number {
  const internalModRegex: RegExp = /\[.*?\]/gi;
  const internalMods: string[] | null = sequence.match(internalModRegex);
  const normalBases: string = sequence.replace(internalModRegex, '');
  return normalBases.length + (internalMods ? internalMods.length : 0);
}

export function deepClone<T extends object>(source: T): T {
  return JSON.parse(JSON.stringify(source));
}

export function countOligos(projects: Model.ProjectItem[]): number {
  return projects.reduce((noOfOligosInApp: number, project: Model.ProjectItem) => {
    return project.oligos.reduce((noOfOligosInProject: number, oligo: Model.OligoItem) => {
      const { definition } = oligo;
      const { advanced } = definition;
      const { alternate } = advanced;
      noOfOligosInProject++;
      noOfOligosInProject = noOfOligosInProject + alternate.selected.length;
      return noOfOligosInProject;
    }, noOfOligosInApp);
  }, 0);
}

export type AmountFormatter = (amount: number, currency: string, language: string, country?: string) => string;
export const formatAmount: AmountFormatter = (amount: number, currency: string, language: string, country?: string): string => {
  const langCode = language.toLowerCase();
  const numDecimals: number = 2;
  const hasDecimal = (amount % 1) !== 0;
  const locale = country ? `${langCode}-${country.toUpperCase()}` : langCode;
  try {
    return `${currency} ${amount.toLocaleString(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'code',
      maximumFractionDigits: numDecimals,
      minimumFractionDigits: hasDecimal ? numDecimals : 0,
    }).replace(currency, '').trim()}`;
  } catch {
    return `${currency} ${amount.toFixed(numDecimals)}`;
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/util.ts